var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 159,
    viewBox: "0 0 162 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_219_8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81,
    cy: 75.5,
    rx: 77,
    ry: 75.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.433 84.0153C33.433 82.515 32.2168 81.2988 30.7165 81.2988C29.2162 81.2988 28 82.515 28 84.0153C28 85.5156 29.2162 86.7318 30.7165 86.7318C32.2168 86.7318 33.433 85.5156 33.433 84.0153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.557 81.0161V85.0978C129.557 85.6254 129.401 86.1165 129.075 86.4737L129.071 86.478C128.753 86.8172 128.308 87.015 127.759 87.015C127.257 87.015 126.847 86.8308 126.541 86.5508C126.181 86.2214 126.007 85.7329 125.953 85.2624L125.902 84.8126L126.802 84.7104L126.853 85.1602C126.892 85.5046 127.011 85.753 127.153 85.8829C127.3 86.0175 127.494 86.1095 127.759 86.1095C128.073 86.1095 128.273 86.0045 128.408 85.8612C128.547 85.7071 128.651 85.4527 128.651 85.0978V81.0161H129.557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.879 81.5676C131.274 81.1992 131.83 81.0161 132.369 81.0161C132.986 81.0161 133.638 81.2694 134.012 81.7199C134.259 82.0155 134.444 82.3581 134.48 82.8273L133.577 82.8962C133.559 82.6589 133.474 82.4888 133.316 82.2994L133.315 82.2982L133.315 82.2982C133.149 82.0977 132.777 81.9216 132.369 81.9216C132.018 81.9216 131.697 82.0432 131.498 82.2288C131.324 82.3932 131.223 82.5716 131.223 82.8271C131.223 82.963 131.28 83.0708 131.386 83.1631C131.5 83.2625 131.66 83.3305 131.807 83.3545C131.939 83.376 132.08 83.3925 132.23 83.4101C132.569 83.4497 132.955 83.4948 133.384 83.6153C133.692 83.7015 133.983 83.9037 134.197 84.1557C134.412 84.4092 134.582 84.7528 134.582 85.1417C134.582 85.7044 134.37 86.0982 134.076 86.3999L134.073 86.4033L134.073 86.4033C133.637 86.8415 133.025 87.015 132.396 87.015C131.752 87.015 131.147 86.8012 130.727 86.3418C130.425 86.0143 130.221 85.5752 130.178 85.0992L131.08 85.0179C131.104 85.29 131.223 85.5437 131.393 85.729L131.394 85.73C131.608 85.9632 131.947 86.1095 132.396 86.1095C132.872 86.1095 133.217 85.9788 133.429 85.7666C133.579 85.6114 133.677 85.4371 133.677 85.1417C133.677 85.0202 133.621 84.8768 133.506 84.7417C133.39 84.6052 133.248 84.5174 133.14 84.4872C132.775 84.385 132.513 84.3553 132.216 84.3216C132.05 84.3028 131.873 84.2828 131.661 84.2481C131.373 84.201 131.051 84.0714 130.792 83.8462C130.525 83.614 130.318 83.2702 130.318 82.8271C130.318 82.2653 130.567 81.8617 130.878 81.5689L130.879 81.5676L130.879 81.5676Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2976 70.433C41.2971 70.433 38.8646 72.8654 38.8646 75.866C38.8646 78.8665 41.2971 81.299 44.2976 81.299V86.732C38.2965 86.732 33.4316 81.8671 33.4316 75.866C33.4316 69.8649 38.2965 65 44.2976 65C50.2987 65 55.1636 69.8649 55.1636 75.866V86.732H49.7306V75.866C49.7306 72.8654 47.2982 70.433 44.2976 70.433Z",
    fill: "#206EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7305 65H55.1635V66.4537C56.7617 65.5291 58.6173 65 60.5965 65C66.5976 65 71.4624 69.8649 71.4624 75.866V86.732H66.0295V75.866C66.0295 72.8654 63.597 70.433 60.5965 70.433C57.5959 70.433 55.1635 72.8654 55.1635 75.866V86.732H49.7305V65Z",
    fill: "#FF324A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4629 65H76.8959V66.4537C78.4941 65.5291 80.3497 65 82.3289 65C88.33 65 93.1949 69.8649 93.1949 75.866V86.732H87.7619V75.866C87.7619 72.8654 85.3294 70.433 82.3289 70.433C79.3283 70.433 76.8959 72.8654 76.8959 75.866V86.732H71.4629V65Z",
    fill: "#206EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6277 70.433C95.6271 70.433 93.1947 72.8654 93.1947 75.866V86.732H87.7617V75.866C87.7617 69.8649 92.6266 65 98.6277 65C104.629 65 109.494 69.8649 109.494 75.866V86.732H104.061V75.866C104.061 72.8654 101.628 70.433 98.6277 70.433Z",
    fill: "#FF324A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0293 75.8659V73.1494H71.4623V75.8659C71.4623 78.8665 73.8947 81.2989 76.8953 81.2989V86.7319C70.8942 86.7319 66.0293 81.867 66.0293 75.8659Z",
    fill: "#31FFA6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.061 75.866C104.061 69.8649 108.925 65 114.927 65C120.928 65 125.793 69.8649 125.793 75.866V81.299H114.927V75.866H120.36C120.36 72.8654 117.927 70.433 114.927 70.433C111.926 70.433 109.494 72.8654 109.494 75.866C109.494 78.8665 111.926 81.299 114.927 81.299V86.732C108.925 86.732 104.061 81.8671 104.061 75.866Z",
    fill: "#31FFA6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2976 70.433C41.2971 70.433 38.8646 72.8654 38.8646 75.866C38.8646 78.8665 41.2971 81.299 44.2976 81.299V86.732C38.2965 86.732 33.4316 81.8671 33.4316 75.866C33.4316 69.8649 38.2965 65 44.2976 65C50.2987 65 55.1636 69.8649 55.1636 75.866V86.732H49.7306V75.866C49.7306 72.8654 47.2982 70.433 44.2976 70.433Z",
    fill: "url(#paint0_radial_219_8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0295 75.866C66.0295 72.8654 63.597 70.433 60.5965 70.433C57.5959 70.433 55.1635 72.8654 55.1635 75.866V86.732H49.7305V75.866C49.7305 69.8649 54.5953 65 60.5965 65C66.5976 65 71.4624 69.8649 71.4624 75.866V86.732H66.0295V75.866Z",
    fill: "url(#paint1_radial_219_8)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1635 65H49.7305V86.732H55.1635V65Z",
    fill: "url(#paint2_radial_219_8)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8959 75.866C76.8959 72.8654 79.3283 70.433 82.3289 70.433C85.3294 70.433 87.7619 72.8654 87.7619 75.866V86.732H93.1949V75.866C93.1949 69.8649 88.33 65 82.3289 65C76.3278 65 71.4629 69.8649 71.4629 75.866H76.8959Z",
    fill: "url(#paint3_radial_219_8)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8959 65H71.4629V86.732H76.8959V65Z",
    fill: "url(#paint4_radial_219_8)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.061 75.866C104.061 72.8654 101.628 70.433 98.6277 70.433C95.6271 70.433 93.1947 72.8654 93.1947 75.866V86.732H87.7617V75.866C87.7617 69.8649 92.6266 65 98.6277 65C104.629 65 109.494 69.8649 109.494 75.866V86.732H104.061V75.866Z",
    fill: "url(#paint5_radial_219_8)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4623 75.8659C71.4623 78.8665 73.8947 81.2989 76.8953 81.2989V86.7319C70.8942 86.7319 66.0293 81.867 66.0293 75.8659V73.1494H71.4623V75.8659Z",
    fill: "url(#paint6_radial_219_8)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7458 70.433C70.2461 70.433 71.4623 69.2168 71.4623 67.7165C71.4623 66.2162 70.2461 65 68.7458 65C67.2455 65 66.0293 66.2162 66.0293 67.7165C66.0293 69.2168 67.2455 70.433 68.7458 70.433Z",
    fill: "url(#paint7_radial_219_8)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.36 75.866C120.36 72.8654 117.927 70.433 114.927 70.433C111.926 70.433 109.494 72.8654 109.494 75.866C109.494 78.8665 111.926 81.299 114.927 81.299V86.732C108.925 86.732 104.061 81.8671 104.061 75.866C104.061 69.8649 108.925 65 114.927 65C120.928 65 125.793 69.8649 125.793 75.866V81.299H120.36H114.927V75.866H120.36Z",
    fill: "url(#paint8_radial_219_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_219_8",
    x: 0,
    y: 0,
    width: 162,
    height: 159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_219_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_219_8",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1120.03 65) scale(1086.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#329FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206EFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1136.33 65) scale(1086.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF324A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(321.38 65) scale(543.299 2173.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF324A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1158.06 65) scale(1086.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#329FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206EFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.113 65) scale(543.299 2173.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206EFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1174.36 65) scale(1086.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF324A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(609.329 73.1494) scale(543.299 679.124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FFFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(337.679 65) scale(271.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FFFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_219_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1190.66 65) scale(1086.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FFFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFA6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimejs);
export default __webpack_public_path__ + "static/media/animejs.ec8113fea010bb35661cdec3fb1e828c.svg";
export { ForwardRef as ReactComponent };